module.exports = __webpack_public_path__ + "static/media/HealthProfessional.08923924.png";